import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { LegacyHeatingModeProvider } from './legacy';
import { HeatingModeContent } from './types';
import { Z3KHeatingModeProvider } from './z3k';
export const HeatingModeProvider = memo(function HeatingModeProvider(props) {
    const { children, config, heating_circuit_id } = props;
    const { is_legacy_device } = useDeviceConfig();
    const Provider = is_legacy_device
        ? LegacyHeatingModeProvider
        : Z3KHeatingModeProvider;
    return (_jsx(Provider, { config: config, heating_circuit_id: heating_circuit_id, children: children }));
});
export const useHeatingMode = () => useContext(HeatingModeContent);
